import * as yup from 'yup';

export const qrCodeSchema = yup.object({
  name: yup.string().required('Partner name is required.'),
  branch_uuid: yup.object().required('Branch is required.').nullable(),
});
